const rebaixasStore = {
    state() {
        return {
            tarefasRebaixas: '',
            categoriaRebaixas: '',
        };
    },
    mutations: {
        setTarefasRebaixas(state, payload) {
            state.tarefasRebaixas = payload;
        },
        setCategoriaRebaixas(state, payload) {
            state.categoriaRebaixas = payload;
        },
        updateRebaixaAplicada(state, payload) {
            let tarefa = state.tarefasRebaixas.find(
                (item) => item.sku === payload.sku && item.data_validade === payload.data_validade
            );
            if (tarefa) {
                tarefa.rebaixa_aplicada = payload.rebaixa_aplicada;
            }
        },
    },
    actions: {
        setTarefasRebaixas(context, payload) {
            context.commit('setTarefasRebaixas', payload);
        },
        setCategoriaRebaixas(context, payload) {
            context.commit('setCategoriaRebaixas', payload);
        },
    },
    getters: {
        getTarefasRebaixas(state) {
            return state.tarefasRebaixas;
        },

        getCategoriasRebaixas(state) {
            let prod = state.tarefasRebaixas;

            return prod.reduce(function (key, element) {
                key[element.categoria_app_nivel_1] = key[element.categoria_app_nivel_1] || [];
                key[element.categoria_app_nivel_1].push(element);
                return key;
            }, Object.create(null));
        },

        getTarefasCategoriaRebaixas(state) {
            let filtrados = state.tarefasRebaixas.filter((element) => {
                return element.categoria_app_nivel_1 == state.categoriaRebaixas;
            });

            return filtrados.reduce(function (key, element) {
                key[element.categoria_app_nivel_2] = key[element.categoria_app_nivel_2] || [];
                key[element.categoria_app_nivel_2].push(element);
                return key;
            }, Object.create(null));
        },

        getTotalTarefasRebaixas(state) {
            return state.tarefasRebaixas.length;
        },
        getCategoriaRebaixas(state) {
            return state.categoriaRebaixas;
        },
    },
};

export default rebaixasStore;
